import React, { useState } from 'react';
import './LoginPage.css';
import { FaUserAlt, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import logosipedas from '../assets/img/logo/logosipedas.png';
import api, { BASE as API_BASE } from '../api';
import { useNavigate, useLocation } from 'react-router-dom';

function LoginPage({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const u = username.trim();
    const p = password; // jangan trim password
    if (!u || !p) {
      setError('Username dan password wajib diisi.');
      return;
    }

    setError('');
    setLoading(true);

    try {
      const res = await api.post(
        '/login',
        { username: u, password: p },
        { withCredentials: false }
      );

      const { token, user } = res.data || {};
      if (!token || !user?.role) throw new Error('Respon login tidak valid');

      localStorage.setItem('token', token);
      localStorage.setItem('role', String(user.role));
      localStorage.setItem('user_id', String(user.id));
      api.defaults.headers.common.Authorization = `Bearer ${token}`;

      if (typeof onLoginSuccess === 'function') {
        onLoginSuccess(user.role, user);
      } else {
        const from = location.state?.from?.pathname || (user.role === 'admin' ? '/admin' : '/regular');
        navigate(from, { replace: true });
      }
    } catch (err) {
      // Prioritaskan pesan validasi Laravel: { errors: { username: ["..."], password: ["..."] } }
      const validation =
        err?.response?.data?.errors &&
        (err.response.data.errors.username?.[0] ||
          err.response.data.errors.password?.[0]);

      const msg =
        validation ||
        err?.response?.data?.message ||
        (err?.response?.status === 401 ? 'Username atau password salah!' : '') ||
        err?.message ||
        'Terjadi kesalahan.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-bg-gradient">
      <div className="login-card-animated">
        <div className="login-card-header">
          <img src={logosipedas} alt="Logo SIPEDAS" className="login-logo" />
          <h2>
            <span style={{ color: '#2188ff' }}>SIPEDAS</span>{' '}
            <span style={{ fontWeight: 400, color: '#444' }}>Login</span>
          </h2>
          <p className="login-desc">Sistem Informasi Pencatatan Data Stok</p>
          <small style={{ opacity: 0.6 }}>API: {API_BASE}</small>
        </div>

        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="login-input-group">
            <FaUserAlt className="login-input-icon" />
            <input
              type="text"
              placeholder="Username"
              autoFocus
              autoComplete="username"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                if (error) setError('');
              }}
              required
            />
          </div>

          <div className="login-input-group">
            <FaLock className="login-input-icon" />
            <input
              type={showPwd ? 'text' : 'password'}
              placeholder="Password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (error) setError('');
              }}
              required
            />
            <button
              type="button"
              className="show-hide-btn"
              onClick={() => setShowPwd((v) => !v)}
              aria-label={showPwd ? 'Sembunyikan password' : 'Tampilkan password'}
              tabIndex={-1}
            >
              {showPwd ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          {error && <div className="login-error">{error}</div>}

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? 'Loading...' : 'Login'}
          </button>
        </form>

        <div className="login-footer">
          <span>© {new Date().getFullYear()} Kemenkes BKK Pangkalpinang</span>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
